<template>
  <svg
    v-if="useAlt"
    :class="customClass"
    viewBox="0 0 16 17"
    fill="none"
    :stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_25805_72134)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.55501 1.61384C9.2574 1.31622 8.77486 1.31622 8.47725 1.61384C8.17963 1.91146 8.17963 2.39399 8.47725 2.69161L13.273 7.4874H0.887097C0.466202 7.4874 0.125 7.8286 0.125 8.2495C0.125 8.67039 0.466202 9.01159 0.887097 9.01159H13.273L8.47725 13.8074C8.17963 14.105 8.17963 14.5875 8.47725 14.8852C8.77486 15.1828 9.2574 15.1828 9.55501 14.8852L15.6518 8.78838C15.9494 8.49076 15.9494 8.00823 15.6518 7.71061L9.55501 1.61384Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_25805_72134">
        <rect x="0.125" y="0.375" width="15.75" height="15.75" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else
    :class="customClass"
    fill="none"
    :stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokeWidth" d="M9 5l7 7-7 7"></path>
  </svg>
</template>

<script>
export default {
  name: "ArrowRight",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
    strokeWidth: {
      type: String,
      default: "2",
    },
    useAlt: {
      type: Boolean,
      default: false,
    },
    currentColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
